import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["truncate"];
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import HubSpotLogo from 'academy-common-lib/components/icon/HubSpotLogo';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { PlayerPlayIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PlayIcon = props => /*#__PURE__*/_jsx(PlayerPlayIcon, Object.assign({}, props, {
  size: "100"
}));
export const WatchOnHubSpotAcademyLink = _ref => {
  let {
      truncate = true
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(Link, Object.assign({}, props, {
    target: "_blank",
    use: "unstyled",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "100",
      children: [/*#__PURE__*/_jsx(Paragraph, {
        color: "text-alert-on-fill-default",
        margin: "0",
        children: truncate && isMobile ? /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "video.watchOnHubSpotAcademyMobile",
          options: {
            hubSpotLogo: /*#__PURE__*/_jsx(HubSpotLogo, {})
          }
        }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "video.watchOnHubSpotAcademy",
          options: {
            hubSpotLogo: /*#__PURE__*/_jsx(HubSpotLogo, {})
          }
        })
      }), /*#__PURE__*/_jsx(IconCircle, {
        backgroundColor: "fill-surface-default",
        borderWidth: "0",
        color: "icon-core-default",
        icon: PlayIcon,
        padding: "50"
      })]
    })
  }));
};